export const formatCompanyDisplayName = (companyName?: string | null): string | undefined => {
  if (!companyName?.trim()) {
    return undefined;
  }

  return companyName.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
};
